/*
 * @Author: Claude
 * @Date: 2025-12-30
 * @Description: VideoUpload 常量
 */

// 支持的视频类型
export const ACCEPT_FILE_TYPES =
  'video/mp4,video/quicktime,video/x-msvideo,video/x-matroska,video/webm';

// 最大文件大小：100MB
export const MAX_FILE_SIZE = 100 * 1024 * 1024;
